const breadCrumb = "Consultas e Relatórios de Apoio - Consultas e Relatórios";

const routes = [
  {
    path: "/relatorio-faturamento",
    name: "relatorio-faturamento",
    meta: {
      allowedPermissions: ["faturamento_pdf"],
      breadCrumb: breadCrumb,
    },
    component: () =>
      import(
        "@/views/Faturamento/RelatorioFaturamento/RelatorioFaturamentoHome.vue"
      ),
  },
];

export default routes;
